<template>
  <div id="page-help" class="d-flex">
    <MainBarMenu />
    <div class="layout-content container-fluid">      
      <h2 class="mt-0 mt-md-3 mt-lg-4">AYUDA</h2>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <!-- .col -->
          <div class="col-12 col-md-0 text-left text-lg-right">
            <div class="cont-search d-flex flex-column align-items-start align-items-md-end">
              <label for="filter d-block">Busca tu pregunta o palabras clave</label>
              <div class="cont-input d-flex">
                <input
                  type="text"
                  class="input-text"
                  v-model="datatable.filter"
                  placeholder="Introduce tu búsqueda..."
                  @keydown="$event.stopImmediatePropagation()"
                />
                <button class="d-flex align-items-center px-3">
                  <span>Buscar</span>
                  <span class="icon icon-search ml-3"></span>
                </button>
              </div>
            </div>
          </div>
          <!-- .col -->
          <!-- .row -->
          <div class="data-table row mt-5 mt-md-5">
            <div class="col-12">
              <div class="table-responsive">
                <datatable
                  :columns="datatable.columns"
                  :data="datatable.rows"
                  :filter="datatable.filter"
                  :per-page="datatable.perPage"
                  :page="datatable.page"
                  sort="id:desc"
                >
                  <template slot-scope="{ row, columns }">
                    <tr @click="funcion(row)">
                      <template>
                        <datatable-cell v-for="(column, j) in columns" 
                          :key="j" 
                          :column="column" 
                          :row="row">
                        </datatable-cell>
                      </template>
                    </tr>
                  </template>
                </datatable>
                <div class="col-12 col-md-6 cont-pagintation">
                  <datatable-pager v-model="datatable.page" type="long" ></datatable-pager>
                </div>

                <div class="cont-no-data" v-show="datatable.rows.length <= 0">
                  <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                    <img src="@/assets/images/demands/user-mail.svg" alt="user email" width="100%" />
                  </div>
                </div>
              </div>
            </div>
            <small v-show="error.flag" class="alert-danger">{{ error.message }}</small>
            <!-- .col-12 -->
            <div class="col-12 col-md-6 text-left cont-pagintation">
              <p
                class="text-1"
              >Mostrando {{datatable.page}} - {{datatable.perPage}} de {{countAllDemands}} Solicitudes</p>
            </div>
            <!-- .col -->
            <div class="col-12 col-md-6 form-inline cont-pagintation text-left text-md-right">
              <!--datatable-pager v-model="datatable.page" type="abbreviated" :per-page="datatable.perPage"></datatable-pager-->
            </div>
            <div class="col-12 d-flex justify-content-center">
              <a 
              class="btn-apoyo"
              href="https://anheuserbuschinbev.sharepoint.com/sites/VIRTUALPARTNER"
              target="blanck"
              >Archivos de Apoyo</a>
            </div>
          </div>      
          <!-- .row -->
          <div class="mb-menu"></div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 px-5 mt-5">
          <div class="mt-5">
            <span v-html="this.faqDetail[this.cont].text"></span>
          </div>
        </div>
      </div>
      
      <!-- .layout-content -->
    </div>
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Help",
  components: {
    MainBarMenu,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      cont: 0,
      faqDetail: [{
        text: '',
      }],
      datatable: {
        filter: "",
        perPage: 9,
        page: 1,
        columns: [
          {
            label: "Id",
            field: "id",
            align: "center",
            sortable: true,
            interpolate: true,
            headerClass: "theading",
          },
          {
            label: "Selecciona una pregunta para ver su respuesta.",
            field: "faq",
            align: "left",
            headerClass: "theading",
          },
        ],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.actGetFaq().then(() =>{
                   this.loadRows();
                   this.faqDetail = this.faq.data;
                })
                .catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "No se pudo conectar al servicio: error: "+response;
                });
    
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["faq"]),

    countAllDemands() {
      return this.datatable.rows.length;
    },
  },
  methods: {
    ...mapActions("modRequest", [
      "actGetFaq"
    ]),

    loadRows(){      
      for(let i=0; i<this.faq.data.length; i++){
        this.datatable.rows.push({
          "id": this.faq.data[i].id, 
          "faq": this.faq.data[i].title,
        });
      }
    },

    funcion(row) {      
      this.cont = this.faqDetail.findIndex(faq => faq.id === row.id);
    }
  },
};
</script>

<style lang="scss">
#page-help {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-help {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }
  .btn-apoyo{
    background-color: #1c6776;
    padding: 10px;
    border-radius: 5px;
    transition: 0.5s;
    color: white;
  }
  .btn-apoyo:hover{
    background-color: #134953;
  }
  .button1 {
    background: #E9ECEE;
    color: #1C3A4E;
    //border-radius: 50px;
    height: 24px;
    font-size: 12px;
    text-align: right !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  /*.div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 70px;
    margin-left: 70px;    
  }*/
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #E9ECEE;
    border-color: #E9ECEE;  
    background: #E9ECEE;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 90%;
    align-self: center;
  }
  .td1 {
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .td2 {
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td3 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 80px;
    //width: 50px;
    text-align: center;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
    
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%; 
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
}
</style>